var _rect, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunitydriven(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 34,
    height: 34,
    rx: 17,
    fill: "url(#paint0_linear_3025_3814)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.75V22.25C20 21.4544 19.6839 20.6913 19.1213 20.1287C18.5587 19.5661 17.7956 19.25 17 19.25H12.5C11.7044 19.25 10.9413 19.5661 10.3787 20.1287C9.81607 20.6913 9.5 21.4544 9.5 22.25V23.75M20 10.346C20.6433 10.5128 21.213 10.8884 21.6198 11.414C22.0265 11.9396 22.2471 12.5854 22.2471 13.25C22.2471 13.9146 22.0265 14.5604 21.6198 15.086C21.213 15.6116 20.6433 15.9872 20 16.154M24.5 23.75V22.25C24.4995 21.5853 24.2783 20.9396 23.871 20.4142C23.4638 19.8889 22.8936 19.5137 22.25 19.3475M17.75 13.25C17.75 14.9069 16.4069 16.25 14.75 16.25C13.0931 16.25 11.75 14.9069 11.75 13.25C11.75 11.5931 13.0931 10.25 14.75 10.25C16.4069 10.25 17.75 11.5931 17.75 13.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3025_3814",
    x1: 0,
    y1: 17,
    x2: 34,
    y2: 17,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#009DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4F5BFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunitydriven);
export default __webpack_public_path__ + "static/media/communitydriven.539b2c9ad9309169c799a023f5739665.svg";
export { ForwardRef as ReactComponent };